import { render, staticRenderFns } from "./TagsSettings.vue?vue&type=template&id=e1f71ebc&"
import script from "./TagsSettings.vue?vue&type=script&lang=ts&"
export * from "./TagsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports